export const POST_TYPE = {
  course: 1,
  article: 2,
  question: 5,
};

export const POST_TYPE_NAME_MAP = {
  1: '视频',
  2: '文章',
  5: '问答',
};

export const POST_TYPE_ROUTER_PATH_MAP = {
  2: 'article',
  5: 'question',
};

export const TOP_CATE_NAME_MAP = {
  xls: '表格',
  doc: '文字',
  ppt: '演示',
  wps: '其他',
  vip: '其他',
  docer: '其他',
  pdf: 'pdf',
};

export const TOP_CATE_MAP = {
  doc: 'word',
  xls: 'excel',
  ppt: 'ppt',
  wps: 'wps',
  pdf: 'pdf',
};

export const COMPONENT_MAP = {
  doc: 'wps',
  xls: 'et',
  ppt: 'wpp',
  wps: 'wps',
};

export const MSG_STATUS = {
  all: 0,
  unread: 1,
  read: 2,
};

export const ITEM_TYPE_REPORT = {
  course: 'skillvideo',
  question: 'skillqa',
  article: 'skillarticle',
};

export const ITEM_TYPE_TO_SORT = {
  1:'video',
  2:'article',
  5:'qa',
};

// 页面底部的预测值，可用于判断是否到页面正文底部
export const FOOTER_HEIGHT = 260;

